import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useContext } from 'react'
import { Link } from 'react-router-dom'
import * as SETTINGS from '../../../constants/settings'
import { SiteConfigContext } from '../../../context/siteConfigContext'

const CustomButton = () => {
  const { [SETTINGS.CUSTOM_BUTTON.key]: customButton } =
    useContext(SiteConfigContext)

  if (!customButton.link || !customButton.text) {
    return null
  }

  return (
    <Link to={customButton.link} target="_blank" rel="noopener noreferrer">
      <button
        className={`header-button button-outline ${customButton.emphasize ? 'animate-boom' : ''}`}
      >
        <span className="hidden md:block">{customButton.text}</span>
        {customButton.icon && (
          <FontAwesomeIcon
            icon={customButton.icon}
            className="header-button-icon"
            // className={`header-button-icon ${customButton.emphasize ? 'animate-spin' : ''}`}
            aria-hidden="true"
          />
        )}
      </button>
    </Link>
  )
}

export default CustomButton
